import BaseService from './BaseService';

const ApiService = {
  async fetchData(param) {
    console.log('🟢 ApiService.fetchData - INÍCIO');
    console.log('🟢 ApiService.fetchData - param:', param);
    console.log('🟢 ApiService.fetchData - param.url:', param?.url);
    console.log('🟢 ApiService.fetchData - param.method:', param?.method);
    console.log('🟢 ApiService.fetchData - param.data:', param?.data);
    
    try {
      console.log('🟢 ApiService.fetchData - Chamando BaseService...');
      const response = await BaseService(param);
      console.log('🟢 ApiService.fetchData - Resposta do BaseService:', response);
      console.log('🟢 ApiService.fetchData - response.data:', response?.data);
      console.log('🟢 ApiService.fetchData - response.status:', response?.status);
      console.log('🟢 ApiService.fetchData - Retornando response');
      return response;
    } catch (errors) {
      console.log('🔴 ApiService.fetchData - ERRO:', errors);
      console.log('🔴 ApiService.fetchData - errors?.response:', errors?.response);
      console.log('🔴 ApiService.fetchData - Lançando erro');
      throw errors;
    }
  },
};

export default ApiService;
